import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CommentState } from './comment.reducer';

export const selectCommentState = createFeatureSelector<CommentState>('comment');

export const selectCommentsForReflex = (reflexNo: string) =>
  createSelector(selectCommentState, (state) => state.entitiesByOrder[reflexNo] ?? []);

export const selectCommentsLoading = createSelector(
  selectCommentState,
  (state) => state.loading
);
